<template>
  <button v-if="buttonVisibility" class="btn btn-feedback mt-1 btn-sm" @click="navigate">
    {{ $t('feedback') }}
  </button>
</template>

<script>
import {ref} from "vue";
import {useFeedbackStore} from "@/store/feedbackStore";
import { useRouter } from "vue-router";
import { captureError } from "@/services/userMonitoring";

export default {
  name: "EnquiryFeedbackButton",
  props: {
    enquiry: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const feedbackStore = useFeedbackStore();
    const buttonVisibility = ref(false);
    const router = useRouter();

    updateButtonVisibility();
    async function updateButtonVisibility() {
      try {
        await feedbackStore.fetchEnquiryFeedbackAnswers();
        const enquiryHasFeedback = feedbackStore.enquiryHasFeedback(props.enquiry.id);
        if (props.enquiry.isReleased === true && enquiryHasFeedback === false && feedbackStore.flow.length >= 1) {
          buttonVisibility.value = true;
        }
      } catch (error) {
        captureError(error);
      }
    }

    const navigate = () => {
      router.push({
        name: 'user-feedback',
        params: {
          id: props.enquiry.quoteCode,
        },
      });
    };
    return {buttonVisibility, navigate};
  }
}
</script>
